interface ITranslationsByLang {
    [index: string]: UiTranslations; // IProduct[];
}

interface UiTranslations {
    buy: string;
    perMonth: string;
    contactUs: string;
    services: string;
    products: string;
    name: string;
    surname: string;
    email: string;
    password: string;
    companyAccount: string;
    companyName: string;
    companyVat: string;
    companyAddress: string;
    companyCity: string;
    companyCountry: string;
    paimentInfo: string;
    creditCardNote: string;
    periodsInMonths: string;
    total: string;
    offersButton: string;
    payButton: string;
}

const eng: UiTranslations = {
    buy: 'Buy',
    perMonth: 'per month',
    contactUs: 'Contact us',
    services: 'Services',
    products: 'Products',
    name: 'Name',
    surname: 'Surname',
    email: 'Email',
    password: 'Password',
    companyAccount: 'This is company account',
    companyName: ' Company Name',
    companyAddress: 'Company address',
    companyCity: 'City',
    companyCountry: 'Country',
    companyVat: 'VAT number',
    paimentInfo: 'Payment info',
    creditCardNote: 'Please note that we do NOT store credit/debit card numbers, nor do we share customer details with any 3rd parties.',
    periodsInMonths: 'payment periods in months',
    total: 'TOTAL',
    offersButton: 'TARIFF PLANS',
    payButton: 'PAY',
};

const ita: UiTranslations = {
    buy: 'Compra',
    perMonth: 'per mese',
    contactUs: 'Contacttaci',
    services: 'Servizi',
    products: 'Prodotti',
    name: 'Nome',
    surname: 'Cognome',
    email: 'Email',
    password: 'Password',
    companyAccount: 'This is company account',
    companyName: 'Nome dell\'azienda',
    companyAddress: 'Indirizzo aziendale',
    companyCity: 'Città',
    companyCountry: 'Paese',
    companyVat: 'Partita IVA',
    paimentInfo: 'Informazioni sul pagamento',
    creditCardNote: 'Si prega di notare che NON memorizziamo i numeri di carta di credito / debito, né condividiamo i dettagli dei clienti con terze parti.',
    periodsInMonths: 'periodi di pagamento in mesi',
    total: 'TOTALE',
    offersButton: 'OFFERTE',
    payButton: 'PAGA',
};

export const uiTranslations: ITranslationsByLang = {
    eng,
    ita,
};
